module.exports = __webpack_public_path__ + "static/media/animated_nagraj.6d74381c.jpg";